export const FETCH_PHOTOS = 'FETCH_PHOTOS';
export const DELETE_PHOTOS = 'DELETE_PHOTOS';
export const ADD_PHOTOS = 'ADD_PHOTOS';
export const EDIT_PHOTOS = 'EDIT_PHOTOS';
